import { ProxyProfile, RelayCommunicationSection } from '@nirvana/shared/dtos/types/policies/common';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { RelayCommunicationSearchableKeywords, RelayUpdateSearchableKeywords } from './relay.types';
import { translateFn } from '../../../../../../utils/translator.helper';

export const RELAY_COMMUNICATION_DEFAULT_VALUE: RelayCommunicationSection = {
  automaticDiscovery: false,
  whitelistedDomains: [],
  cloudServicesProxy: {
    profile: ProxyProfile.KEEP_CURRENT_SETTINGS,
  },
  applianceProxy: {
    profile: ProxyProfile.KEEP_CURRENT_SETTINGS,
  },
};
export const RELAY_UPDATE_DEFAULT_VALUE_FOR_CLOUD = {
  updateInterval: {
    enable: true,
    hours: 1,
  },
  downloadFolder: '',
  updateLocations: {
    enable: true,
    locations: [],
  },
};
export const RELAY_UPDATE_DEFAULT_VALUE_FOR_ONPREMISE = {
  updateInterval: {
    enable: true,
    hours: 1,
  },
  downloadFolder: '',
  updateLocations: {
    enable: false,
    locations: [],
  },
};

export const MIN_UPDATE_HOUR = 1;
export const MAX_UPDATE_HOUR = 24;

// searchable keywords
export function getRelayCommunicationSearchableKeywords(): {
  [type in RelayCommunicationSearchableKeywords]: SearchableKeyword;
} {
  return {
    [RelayCommunicationSearchableKeywords.Relay]: {
      translatedLabel: translateFn('Relay'),
      label: 'Relay',
    },
    [RelayCommunicationSearchableKeywords.Communication]: {
      translatedLabel: translateFn('Communication'),
      label: 'Communication',
    },
    [RelayCommunicationSearchableKeywords.AutomaticDiscovery]: {
      translatedLabel: translateFn('Automatic discovery of new endpoints'),
      label: 'Automatic discovery of new endpoints',
    },
    [RelayCommunicationSearchableKeywords.CommunicationBetweenRelaysAndCloudServices]: {
      translatedLabel: translateFn('Communication between Relays and Cloud Services'),
      label: 'Communication between Relays and Cloud Services',
    },
    [RelayCommunicationSearchableKeywords.CommunicationBetweenRelaysAndGz]: {
      translatedLabel: translateFn('Communication between Relays and GravityZone'),
      label: 'Communication between Relays and GravityZone',
    },
    [RelayCommunicationSearchableKeywords.WhitelistedDomains]: {
      translatedLabel: translateFn('Whitelisted domains for API data upload'),
      label: 'Whitelisted domains for API data upload',
    },
    [RelayCommunicationSearchableKeywords.UseProxy]: {
      translatedLabel: translateFn('Use proxy defined in Agent > Settings'),
      label: 'Use proxy defined in Agent > Settings',
    },
    [RelayCommunicationSearchableKeywords.DoNotUseProxy]: {
      translatedLabel: translateFn('Do not use proxy'),
      label: 'Do not use proxy',
    },
  };
}
export function getRelayUpdateSearchableKeywords(): {
  [type in RelayUpdateSearchableKeywords]: SearchableKeyword;
} {
  return {
    [RelayUpdateSearchableKeywords.Update]: {
      translatedLabel: translateFn('Update'),
      label: 'Update',
    },
    [RelayUpdateSearchableKeywords.CheckForUpdates]: {
      translatedLabel: translateFn('Check for updates every'),
      label: 'Check for updates every',
    },
    [RelayUpdateSearchableKeywords.DownloadFolder]: {
      translatedLabel: translateFn('Download folder'),
      label: 'Download folder',
    },
    [RelayUpdateSearchableKeywords.UpdateLocations]: {
      translatedLabel: translateFn('Update locations'),
      label: 'Update locations',
    },
  };
}
